<template>
<div id="index">
  <div class="init" @click="checkAuth">
    <img class="banner" src="../img/banner.jpg" alt="">
    <img class="car" :src="$state.currentBrand.img" alt="">
    <button class="start-btn">开始探宝领红包</button>
  </div>
  <img class="rule" src="../img/index2.png" alt="">
  <img class="rule" src="../img/index1.png" alt="">
  <div class="rule-btn" @click="jumpRule">活动规则</div>
</div>
</template>

<script>
import {
  getQueryString,isAlipay,isWechat
} from 'common/js/util'
import functions from '../mixins/functions'
export default {
  name: 'index',
  data() {
    return {

    }
  },
  created() {
    const bid = getQueryString('bid')
    this.getRandomBrand(bid)
  },
  mixins: [functions],
  methods: {
    async checkAuth() {
      const url = `${this.$baseURL.cat}/dist/seven190703/game.html${window.location.search}`
      const car = this.$state.currentBrand.id
      let params = ''
      if(!getQueryString('bid')){//如果没有品牌Id,将随机的品牌传入
        const par = window.location.search ? '&' : '?'
        params = `${par}car=${car}`
      }
      const res = await this.$get({
        baseURL: this.$baseURL.cat,
        url: '/auth/alipay/check_auth',
        params: {
          callback: encodeURIComponent(url)
        },
        loading: true,
        autoAuth: false
      })
      // 统计信息
      let label
      if (isAlipay) {
        label = '支付宝'
      } else if (isWechat) {
        label = '微信'
      } else {
        label = '其他'
      }
      typeof _czc !== 'undefined' && _czc.push(['_trackEvent', `${this.$key}`, '授权', label])
      if (res.code === 0) {
        window.location.href = url+params
      } else if (res.code === 5) {
        window.location.href = res.data.jump_url
      } else {
        this.$toast(res.msg)
      }
    },
    jumpRule(){
      if(isAlipay){
        const url = `${this.$baseURL.cat}/dist/${this.$key}/rule.html`
        ap.pushWindow(url)
      }else{
        window.location.href=`${this.$baseURL.cat}/dist/${this.$key}/rule.html`
      }
    },
  },
  components: {

  }
}
</script>

<style lang="scss">
body {
    background: #0062fd;
}
.rule {
    width: 710px;
    margin: 0 auto;
}
.init {
    position: relative;
    width: 750px;
    height: 978px;
    display: flex;
    align-items: flex-end;
    .banner {
        position: absolute;
        width: 100%;
        height: 978px;
    }
    .car {
        position: absolute;
        top: 622px;
        left: 20px;
        width: 343px;
        height: 188px;
    }
    .start-btn {
        width: 416px;
        height: 80px;
        line-height: 80px;
        border-radius: 40px;
        font-size: 36px;
        margin: 0 auto 80px;
        display: block;
        animation: btnScale 1.2s infinite ease-in;
    }
}

.rule-btn {
    width: 190px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 25px;
    border: 1px solid #3eaeff;
    color: #3eaeff;
    margin: 20px auto;
}
</style>
